// CookieConsentBanner.tsx
import React, { useEffect, useState } from 'react';
import './CookieConsentBanner.scss';
import { ReactComponent as Cookie } from "../../../assets/cookie.svg";
import { useTranslation } from 'react-i18next';

const CookieConsentBanner = ({ onConsentGiven }: { onConsentGiven: () => void }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    } else if (consent === 'true') {
      onConsentGiven();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'true');
    setVisible(false);
    onConsentGiven();
  };

  const declineCookies = () => {
    localStorage.setItem('cookie_consent', 'false');
    setVisible(false);
  };

  if (!visible) return <div className='cookie-icon' onClick={() => setVisible(true)}>
    <Cookie />
  </div>

  return (
    <div className="cookie-banner">
      <h2>
        {t('cookie.title')}
      </h2>
      <p>
        {t('cookie.text')}
        <br />
        <a href="https://www.co2logic.com/privacy-policy" rel="noopener" target="_blank" aria-label="More information about your privacy, opens in a new tab" tabIndex={0}>{t('cookie.moreInfoBtn')}</a>
      </p>
      <div>
        <button className='accept-btn' onClick={acceptCookies}>{t('cookie.acceptBtn')}</button>
        <button onClick={declineCookies}>{t('cookie.desclineBtn')}</button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
